import { BlogPostContent } from '@/types/blog';
import { intro } from './sections/intro';
import { warumMusik } from './sections/warum-musik';
import { dopamin } from './sections/dopamin';
import { bpmPrinzip } from './sections/bpm-prinzip';
import { praxis } from './sections/praxis';
import { naechsterSchritt } from './sections/naechster-schritt';
import { faq } from './sections/faq';
import { quellen } from './sections/quellen';

export const content: BlogPostContent = {
  sections: [
    intro,
    warumMusik,
    dopamin,
    bpmPrinzip,
    praxis,
    naechsterSchritt,
    faq,
    quellen
  ]
};
